<template>
    <div class="v2-retailer-brands__row">
        <div v-if="isRetailer" class="v2-retailer-brands__cell-favorite">
            <div
                :class="{ active: isFavourite }"
                class="cabinet-btn-icon cabinet-btn-icon--small cabinet-btn-icon--favorite"
                @click="changeFavourite(brand, isFavourite)"
            ></div>
        </div>

        <router-link
            :to="`${isRetailerPatch}/brands/${brand.BrandID}`"
            class="v2-retailer-brands__logo"
        >
            <img :src="brand.logo" alt="" class="v2-retailer-brands__img ofi" />
        </router-link>

        <div class="v2-retailer-brands__name">
            <router-link :to="`${isRetailerPatch}/brands/${brand.BrandID}`">
                {{ brand.BrandName }}
            </router-link>
            <i
                v-if="brand.has_restricted_items"
                :class="
                    brand.approved_access_to_restricted_items
                        ? 'icon-unlock'
                        : 'icon-lock'
                "
            >
                <div class="cabinet__catalog-tooltip">
                    <div class="cabinet__catalog-tooltip_text">
                        <template>
                            {{
                                brand.approved_access_to_restricted_items
                                    ? 'Вам открыт доступ к скрытым изделиям этого бренда'
                                    : 'У бренда есть скрытые изделия'
                            }}
                        </template>
                    </div>
                    <div class="cabinet__catalog-tooltip_link">
                        <a
                            v-if="
                                brand.access_status === null ||
                                    brand.access_status === 'forbidden'
                            "
                            href="javascript:void(0)"
                            @click.prevent="
                                $emit('onClickToRequestAccess', brand)
                            "
                        >
                            Запросить доступ
                        </a>
                        <span
                            v-if="brand.access_status === 'new'"
                            class="color-gray"
                        >
                            Запрос доступа отправлен
                        </span>
                    </div>
                </div>
            </i>
        </div>

        <div v-if="isRetailer" class="v2-retailer-brands__subscription">
            <label class="app-checkbox">
                <input
                    v-model="isSubscribed"
                    type="checkbox"
                    :checked="isSubscribed"
                    @change="changeSubscription()"
                />
                <span class="app-checkbox__checkmark"></span>
                Получать уведомления о новинках
            </label>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import checkDemoUser from '@/mixins/checkDemoUser.js'

export default {
    name: 'BrandItem',
    mixins: [checkDemoUser],
    props: {
        brand: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isSubscribed: this.brand.is_subscribed,
            isFavourite: this.brand.is_favorited
        }
    },
    computed: {
        ...mapGetters('user', ['isRetailer']),
        isRetailerPatch() {
            return this.isRetailer ? '/account' : ''
        }
    },
    methods: {
        changeFavourite() {
            if (this.isDemoUserMode()) return

            this.isFavourite = !this.isFavourite
            this.$emit('change-favourite', this.brand, this.isFavourite)
        },
        changeSubscription() {
            if (this.isDemoUserMode()) {
                this.$nextTick(() => {
                    this.isSubscribed = this.brand.is_subscribed
                })
                return
            }
            this.$emit('change-subscription', this.brand, this.isSubscribed)
        }
    }
}
</script>
